import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../context/AuthContext';
import apiService from '../../../services/api';
import TeamFeedback from './TeamFeedback';
import SafeIcon from '../../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUserCheck } = FiIcons;

const TeamFeedbackPage = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [members, setMembers] = useState([]);

  useEffect(() => {
    if (user?.teamId) {
      fetchMembers();
    }
  }, [user]);

  const fetchMembers = async () => {
    setLoading(true);
    try {
      const relationsRes = await apiService.getUserTeamRelations({ team_id: user.teamId });
      if (relationsRes.status === 'success' && Array.isArray(relationsRes.data)) {
         const relations = relationsRes.data;
         
         const memberPromises = relations.map(async (rel) => {
            try {
               const userRes = await apiService.getUserById(rel.user_id);
               let userData = null;
               if (userRes) {
                 if (Array.isArray(userRes.data)) {
                   userData = userRes.data[0];
                 } else if (userRes.data && typeof userRes.data === 'object') {
                   userData = userRes.data;
                 } else {
                   userData = userRes;
                 }
               }
               if (userData) {
                 const name = userData.name || `${userData.firstname || ''} ${userData.lastname || ''}`.trim();
                 const email = userData.email || userData.mail;
                 if (name || email) {
                    return {
                      ...userData,
                      id: userData.id || rel.user_id,
                      name: name || 'Kein Name',
                      email: email || 'Keine E-Mail',
                      relationId: rel.id,
                      role: rel.role || 'member',
                      feedback_active: userData.feedback_active
                    };
                 }
               }
               return null;
            } catch (e) {
               console.warn(`Could not fetch user ${rel.user_id}`, e);
               return null;
            }
         });
         
         const fetchedMembers = (await Promise.all(memberPromises)).filter(m => m !== null);
         setMembers(fetchedMembers);
      }
    } catch (e) {
      console.error("Error fetching members", e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full min-h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-primary"></div>
      </div>
    );
  }

  return (
    <div className="p-6 w-full relative">
      <div className="mb-6 flex-shrink-0">
        <h1 className="text-2xl font-bold text-brand-dark flex items-center">
          <SafeIcon icon={FiUserCheck} className="w-7 h-7 mr-3 text-brand-secondary" />
          Team Feedback
        </h1>
        <p className="text-gray-600 mt-2">
          Geben und erhalten Sie wertvolles Feedback von Ihren Teammitgliedern.
        </p>
      </div>
      
      <TeamFeedback members={members} />
    </div>
  );
};

export default TeamFeedbackPage;